import {defineCssVars, defineStyleConfig} from '@chakra-ui/styled-system';

export const {
  color: $color,
  gap: $gap,
  justify: $justify,
} = defineCssVars(`pagination-list`, [`color`, `gap`, `justify`]);

export const listCssVars = {
  [$color.variable]: `inherit`,
  [$gap.variable]: `space.16`,
  [$justify.variable]: `space-between`,
};

export const listStyle = defineStyleConfig({
  baseStyle: {
    display: `flex`,
    gap: $gap.reference,
    justifyContent: $justify.reference,
    color: $color.reference,
  },
});
